import Exif from '@/javascripts/exif';

document.addEventListener('DOMContentLoaded', () => {
  const exif = new Exif();
  ['addAccordionAria', 'addAccordionEvent'].forEach((fn) =>
    (exif as any)[fn](document.querySelector('.js-image-attribute-accordion'))
  );
});
